import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboard: null,

  recommendations: null,
  recommendationsLoading: false,
  recommendationsError: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboard: (state, action) => {
      state.dashboard = action.payload.dashboard;
    },

    updateDashboard: (state, action) => {
      const updated = action.payload.dashboard;
      if (state.dashboard && updated && state.dashboard._id === updated._id) {
        state.dashboard = updated;
      }
    },

    removeDashboard: (state, action) => {
      const { dashboardId } = action.payload;
      if (state.dashboard && state.dashboard._id === dashboardId) {
        state.dashboard = null;
      }
    },

    addToDashboard: (state, action) => {
      const newItem = action.payload.item;
      if (!state.dashboard || !newItem) return;
      if (!Array.isArray(state.dashboard.dynamicData)) state.dashboard.dynamicData = [];
      if (!Array.isArray(state.dashboard.orderData)) state.dashboard.orderData = [];
      state.dashboard.dynamicData.push(newItem);
      if (newItem._id && !state.dashboard.orderData.includes(newItem._id)) {
        state.dashboard.orderData.push(newItem._id);
      }
    },

    setRecommendationsLoading: (state, action) => {
      state.recommendationsLoading = !!action.payload;
    },

    setRecommendations: (state, action) => {
      state.recommendations = action.payload || null;
      state.recommendationsError = null;
    },

    setRecommendationsError: (state, action) => {
      state.recommendationsError = action.payload || "Erro ao carregar recomendações";
    },

    resetDashboard: () => initialState,
  },
});

export const {
  setDashboard,
  updateDashboard,
  removeDashboard,
  resetDashboard,
  addToDashboard,

  setRecommendationsLoading,
  setRecommendations,
  setRecommendationsError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;